import { Layout } from "@shopify/polaris";
import ResourceSelector from "./ResourceSelector";
import Api from "../../../helpers/api";
import {useState} from "react";

export default ({
    leftCardTitle = '',
    rightCardTitle = '',
    searchPlaceholder = '',
    resourceName = { singular: 'company', plural: 'companies' },
    onAdd = (id) => {},
    onRemove = (id) => {},
    onLoadLeftResources = (params) => {},
    onLoadRightResources = (params) => {},
    renderItem = (item) => {}
}) => {
    const [adding, setAdding] = useState(false);
    const [removing, setRemoving] = useState(false);
    const [rerenderCounter, setRerenderCounter] = useState(1);

    const onResourceAdd = (resource) => {
        setAdding(true);

        onAdd(resource.id)
            .then(() => {
                setRerenderCounter(oldCount => oldCount+1);
            })
            .finally(() => setAdding(false));
    }

    const onResourceRemove = (resource) => {
        setRemoving(true);

        onRemove(resource.id)
            .then(() => {
                setRerenderCounter(oldCount => oldCount+1);
            })
            .finally(() => setRemoving(false));
    }

    return (<Layout>
        <Layout.Section variant="oneHalf">
            <ResourceSelector
                loading={adding}
                loadResources={onLoadLeftResources}
                onAction={onResourceAdd}
                resourceName={resourceName}
                actionLabel={"Add"}
                cardTitle={leftCardTitle}
                searchFieldLabel={searchPlaceholder}
                hidePagination
                renderItem={renderItem}
                forceSearchLength
            />
        </Layout.Section>
        <Layout.Section variant="oneHalf">
            <ResourceSelector
                loading={removing}
                resourceName={resourceName}
                loadResources={onLoadRightResources}
                onAction={onResourceRemove}
                actionLabel={"Remove"}
                cardTitle={rightCardTitle}
                searchFieldLabel={searchPlaceholder}
                renderCounter={rerenderCounter}
                renderItem={renderItem}
                autoLoad
            />
        </Layout.Section>
    </Layout>);
}
